import React, { useEffect, useState } from 'react'
import firebase from '../../firebase'
import { DataInput } from './DataInput';
import Header from '../Header'

import { TextField, Grid, Button, MenuItem } from '@material-ui/core';

export default function AppData({ location }) {
    const category = location.state.category
    const [data, setData] = useState([])
    const [title, setName] = useState('');
    const [price, setPrice] = useState(0);
    const [itemCategory, setCategory] = useState(category);
    const [image, setImage] = useState('');
    const [desc, setDesc] = useState('');

    const categories = [
        {
            id: 1,
            value: 'liquors',
            label: 'Pack selection'
        },
        {
            id: 2,
            value: 'Whiskey12',
            label: 'Whiskey 12 Years',
        },
        {
            id: 3,
            value: 'Whiskey15',
            label: 'Whiskey 15 Years',
        },
        {
            id: 4,
            value: 'Whiskey18',
            label: 'Whiskey 18 Years',
        },
        {
            id: 5,
            value: 'Champagne',
            label: 'Champagne',
        },
    ];
    const categoriesDD = [
        {
            id: 1,
            value: 'liquorsDD',
            label: 'Pack selection'
        },
        {
            id: 2,
            value: 'Whiskey12DD',
            label: 'Whiskey 12 Years',
        },
        {
            id: 3,
            value: 'Whiskey15DD',
            label: 'Whiskey 15 Years',
        },
        {
            id: 4,
            value: 'Whiskey18DD',
            label: 'Whiskey 18 Years',
        },
        {
            id: 5,
            value: 'ChampagneDD',
            label: 'Champagne',
        },
    ];

    const onCreate = () => {
        const db = firebase.firestore();
        if (category === 'Promo') {
            if (desc === '') {
                alert('Please choose a category')
            }
            else {
                const label = categoriesDD.find(e => e.value === desc);
                db.collection(`${category}`).add({ image, category: itemCategory === 'FreeDD' ? 'Social' : itemCategory.replace('DD', ''), desc, label: label.label });
                setName('');
                setPrice(0);
                setImage('');
                setDesc('');
            }

        }
        else if (category === 'Discounted') {
            if (desc === '') {
                alert('Please choose a category')
            }
            else {
                const label = categories.find(e => e.value === desc);
                db.collection(`${category}`).add({ image, category: itemCategory === 'FreeDD' ? 'Social' : itemCategory.replace('DD', ''), desc, label: label.label });
                setName('');
                setPrice(0);
                setImage('');
                setDesc('');
            }
        }
        else {
            db.collection(`${category}`).add({ title, price, image, category: itemCategory === 'FreeDD' ? 'Social' : itemCategory.replace('DD', ''), desc });
            setName('');
            setPrice(0);
            setImage('');
            setDesc('');
        }
    }


    useEffect(() => {
        console.log('called')
        const db = firebase.firestore();
        return db.collection(`${category}`).onSnapshot((snapshot) => {
            const data = []
            snapshot.forEach(doc => data.push(({ ...doc.data(), id: doc.id })))
            setData(data)
        });

    }, [])
    return (
        <>
            <Header />
            <div style={{ marginLeft: 20 }}>
                <h2>Add items</h2>

                {category === 'Discounted' ?
                    <Grid container spacing={4}>
                        {/* <Grid item xs={12} md={2}>
                        <TextField
                            id="standard-helperText"
                            label="Name"
                            required
                            value={title}
                            onChange={(e) => setName(e.target.value)}
                            autoComplete='off'
                        />
                    </Grid> */}
                        {/* <Grid item xs={12} md={2}>
                        <TextField
                            id="standard-helperText"
                            label="Price"
                            required
                            type="number"
                            value={price}
                            onChange={(e) => setPrice(parseInt(e.target.value))}
                            autoComplete='off'
                        />
                    </Grid> */}
                        <Grid item xs={12} md={2}>
                            <TextField
                                id="standard-helperText"
                                label="Image"
                                required
                                value={image}
                                onChange={(e) => setImage(e.target.value)}
                                autoComplete='off'
                            />
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <TextField
                                id="standard-helperText"
                                required
                                value={desc}
                                select
                                label="Select"
                                onChange={(e) => setDesc(e.target.value)}
                                helperText="Please select your category"
                            >
                                {categories.map((option) => (
                                    <MenuItem key={option.id} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                        <Grid item xs={4} md={2} >
                            <Button
                                onClick={onCreate}
                                style={{ marginTop: 10 }} variant="contained">Add</Button>
                        </Grid>

                    </Grid> : category === 'Promo' ?
                        <Grid container spacing={4}>
                            {/* <Grid item xs={12} md={2}>
                        <TextField
                            id="standard-helperText"
                            label="Name"
                            required
                            value={title}
                            onChange={(e) => setName(e.target.value)}
                            autoComplete='off'
                        />
                    </Grid> */}
                            {/* <Grid item xs={12} md={2}>
                        <TextField
                            id="standard-helperText"
                            label="Price"
                            required
                            type="number"
                            value={price}
                            onChange={(e) => setPrice(parseInt(e.target.value))}
                            autoComplete='off'
                        />
                    </Grid> */}
                            <Grid item xs={12} md={2}>
                                <TextField
                                    id="standard-helperText"
                                    label="Image"
                                    required
                                    value={image}
                                    onChange={(e) => setImage(e.target.value)}
                                    autoComplete='off'
                                />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <TextField
                                    id="standard-helperText"
                                    required
                                    value={desc}
                                    select
                                    label="Select"
                                    onChange={(e) => setDesc(e.target.value)}
                                    helperText="Please select your category"
                                >
                                    {categoriesDD.map((option) => (
                                        <MenuItem key={option.id} value={option.value}>
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </Grid>
                            <Grid item xs={4} md={2} >
                                <Button
                                    onClick={onCreate}
                                    style={{ marginTop: 10 }} variant="contained">Add</Button>
                            </Grid>

                        </Grid> :
                        <Grid container spacing={4}>
                            <Grid item xs={12} md={2}>
                                <TextField
                                    id="standard-helperText"
                                    label="Name"
                                    required
                                    value={title}
                                    onChange={(e) => setName(e.target.value)}
                                    autoComplete='off'
                                />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <TextField
                                    id="standard-helperText"
                                    label="Price"
                                    required
                                    type="number"
                                    value={price}
                                    onChange={(e) => setPrice(parseInt(e.target.value))}
                                    autoComplete='off'
                                />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <TextField
                                    id="standard-helperText"
                                    label="Image"
                                    required
                                    value={image}
                                    onChange={(e) => setImage(e.target.value)}
                                    autoComplete='off'
                                />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <TextField
                                    id="standard-helperText"
                                    label="Description"
                                    required
                                    value={desc}
                                    onChange={(e) => setDesc(e.target.value)}
                                    autoComplete='off'
                                />
                            </Grid>
                            <Grid item xs={4} md={2} >
                                <Button
                                    onClick={onCreate}
                                    style={{ marginTop: 10 }} variant="contained">Add</Button>
                            </Grid>

                        </Grid>}


                <h2>Items List</h2>


                {data.map(item => (
                    <div key={item.id}>
                        <DataInput data={item} category={category} />
                    </div>
                ))}
            </div>

        </>
    )
}